import '../styles/index.scss';
const images = require('../data/digital.json');
import ImageGrid from './ImageGrid';

const grid = new ImageGrid(images.images, '.grid-container');

grid.init();
